import { Card, Group, Title, Center, Text, Loader, Grid, Button, Stack, ComboboxItem } from "@mantine/core"
import { IconAdjustmentsHorizontal, IconPencil, IconPlus } from "@tabler/icons-react"

import { useProgramRegistrationState } from "../../state/programregistration.state";
import { formatDateRange, formatDiscountAmount } from "../../functions/programregistration.functions";
import { useProgramPromotionCodesQuery } from "../../api/promotion.api";
import { useTransactionByIdQuery } from "../../api/transaction.api";
import DiscountEditor from "./DiscountEditor";

const DiscountView = () => {
	const { programRegistration, updateProgramRegistration, isLoading: isLoadingRegistration, status } = useProgramRegistrationState();
	const { data: promotionCodes, isLoading } = useProgramPromotionCodesQuery(programRegistration.Data.ProgramGroupId ?? 0);
	const { data: transaction, isLoading: isLoadingTransaction } = useTransactionByIdQuery(programRegistration.TransactionId ?? 0);

	const isSetup = status.isSaved || programRegistration.Data.PromotionCode;
	const canRemove = status.canEdit && programRegistration.Data.PromotionCode && !status.isCancelled && (programRegistration.TransactionId == 0 || transaction && transaction.Paid == 0) && !isLoadingTransaction;

	const handleEditPromotionCode = () => {
		programRegistration.Data.PromotionCode = undefined;
		updateProgramRegistration(programRegistration);
	}

	if (isLoading || promotionCodes === undefined || promotionCodes.length === 0)
		return <></>

	if (!programRegistration.Data.PromotionCode)
		return <Card shadow="lg" withBorder mb="sm">
			<Group justify="space-between" wrap="nowrap">
				<Group gap="xs" mb="sm" wrap="nowrap">
					<IconAdjustmentsHorizontal />
					<Title order={3} lineClamp={1}>Promotion Code</Title>
				</Group>
				<DiscountEditor />
			</Group>

			<Group>
				<Center h={50} mx="auto">
					<Text c="dimmed">No promotion code applied</Text>
				</Center>
			</Group>

		</Card>

	return <>
		<Card shadow="lg" withBorder mb="sm">
			<Group justify="space-between" wrap="nowrap">
				<Group gap="xs" mb="sm" wrap="nowrap">
					<IconAdjustmentsHorizontal />
					<Title order={3} lineClamp={1}>Promotion Code</Title>
				</Group>
				<DiscountEditor />
				{/* <Button variant="light" size="xs" onClick={handleEditPromotionCode} disabled={!canRemove} leftSection={<IconPencil />}>Edit</Button> */}
			</Group>


			{isLoadingRegistration && isSetup && <Center h={50} mx="auto">
				<Loader />
			</Center>}

			{!isLoadingRegistration && isSetup &&
			<Grid mb="xs">
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Discount Code:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text component="code">{programRegistration.Data.PromotionCode?.Code}</Text></Grid.Col>
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Amount:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text>{programRegistration.Data.PromotionCode && formatDiscountAmount(programRegistration.Data.PromotionCode)}</Text></Grid.Col>
			</Grid>
			}
		</Card>
	</>
}

export default DiscountView